(function () {
  class ApiClient {
    constructor() {
      this.baseUrl = "https://app.socalbiomed.com";
    }

    async get(endpoint, params = {}) {
      const url = new URL(`${this.baseUrl}${endpoint}`);
      Object.keys(params).forEach((key) =>
        url.searchParams.append(key, params[key]),
      );

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.statusText}`);
      }

      return response.json();
    }

    async post(endpoint, data = {}) {
      const url = new URL(`${this.baseUrl}${endpoint}`);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        let errorData;
        try {
          const responseText = await response.text();
          errorData = JSON.parse(responseText);
        } catch (e) {
          errorData = { message: response.statusText };
        }

        const error = new Error(`API Error: ${response.statusText}`);
        error.responseData = errorData;
        error.status = response.status;
        throw error;
      }

      return response.json();
    }
  }

  const apiClient = new ApiClient();

  function renderQuoteButton() {
    function getSelectedVariantId() {
      const variantInput = document.querySelector(
        'select[name="id"], input[name="id"]',
      );
      if (variantInput?.value) return variantInput.value;

      const urlParams = new URLSearchParams(window.location.search);
      const variantParam = urlParams.get("variant");
      if (variantParam) return variantParam;

      return window?.dsQuoteData?.selectedVariant?.id;
    }

    function getQuantity() {
      const quantityInput = document.querySelector('input[name="quantity"]');
      return quantityInput?.value || 1;
    }

    function addToQuoteCart() {
      const productBuilder = document.querySelector(
        ".product__config-option-value-input",
      );

      let quoteItem = {
        id: new Date().getTime(),
        variants: [],
        accessories: [],
      };

      if (productBuilder) {
        document
          .querySelectorAll(".product__config-option-value-input:checked")
          .forEach((item) => {
            let id = item.value;

            let quantityInput = document.querySelector(
              `[name="quantity-${id}"]`,
            );

            let quantity = parseInt(quantityInput.value) ?? 0;

            let type = item.getAttribute("data-type");

            let variant = variant_list.find((v) => v.id == id);

            if (!variant) return;

            let variantItem = {
              productId: variant.product.id,
              productTitle: variant.product.title,
              variantTitle: variant.title,
              featureImage:
                variant.featured_image || variant.product.featured_image,
              variantId: variant.id,
              quantity: parseInt(quantity) || 1,
              price: variant.price,
              compareAtPrice: variant.compare_at_price,
            };

            if (variant.options && variant.option_names) {
              variantItem.options_with_values = variant.option_names.map(
                (name, index) => ({
                  name,
                  value: variant.options[index],
                }),
              );
            } else {
              variantItem.options_with_values = [
                {
                  name: "Option",
                  value: variant.title,
                },
              ];
            }

            if (type === "main") {
              quoteItem.variants.push(variantItem);
            } else if (type === "accessory") {
              quoteItem.accessories.push(variantItem);
            }
          });
      } else {
        let id = getSelectedVariantId();

        let quantity = getQuantity();

        let variant = window.dsQuoteData.product.variants.find(
          (v) => v.id == id,
        );

        if (!variant) return;

        let product = window.dsQuoteData.product;

        let variantItem = {
          productId: product.id,
          productTitle: product.title,
          variantTitle:
            product?.variants?.length == 1 ? product?.title : variant.title,
          featureImage: variant.featured_image || product.featured_image,
          variantId: variant.id,
          quantity: parseInt(quantity) || 1,
          price: variant.price,
          compareAtPrice: variant.compare_at_price,
        };

        quoteItem.variants.push(variantItem);
      }

      if (quoteItem?.variants?.length == 0) {
        return;
      }

      let existingCart = JSON.parse(
        localStorage.getItem("dsQuoteCart") || "[]",
      );

      existingCart.push(quoteItem);

      localStorage.setItem("dsQuoteCart", JSON.stringify(existingCart));
    }

    let button = document.querySelector("[data-quote-button]");

    if (button) {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const customerId = window?.dsQuoteData?.customer?.id;

        if (!customerId) {
          const returnUrl = encodeURIComponent(window.location.href);
          window.location = window?.dsQuoteData?.loginUrl
            ? window?.dsQuoteData?.loginUrl
            : `/account/login?return_url=${returnUrl}`;
          return;
        }

        addToQuoteCart();

        const modal = document.querySelector(".ds-quote-modal");

        if (modal) {
          modal.classList.add("ds-quote-modal--open");
        }
      });
    }
  }

  function renderQuoteModal() {
    const customer = window?.dsQuoteData?.customer || {};

    const fields = [
      {
        name: "firstName",
        type: "text",
        placeholder: "First Name",
        value: customer.first_name || "",
      },
      {
        name: "lastName",
        type: "text",
        placeholder: "Last Name",
        value: customer.last_name || "",
      },
      {
        name: "email",
        type: "email",
        placeholder: "Email",
        value: customer.email || "",
      },
      {
        name: "phone",
        type: "tel",
        placeholder: "Phone Number",
        value: customer.phone || "",
      },
      {
        name: "company",
        type: "text",
        placeholder: "Company",
        value: customer.company || "",
      },
    ];

    const formSection = `
      <form class="ds-quote-form ds-quote-section">
        <h4 class="ds-quote-section-title">Personal Information</h4>
        <div class="ds-quote-form__field-list">
          ${fields
            .map(
              (field) => `
            <div class="ds-quote-form__field">
              <label for="${
                field.name
              }" class="ds-quote-form__field-label visually-hidden">
                ${field.placeholder}
              </label>
              <input 
                class="ds-quote-form__field-input"
                type="${field.type}"
                name="${field.name}"
                id="${field.name}"
                placeholder="${field.placeholder}"
                aria-label="${field.placeholder}"
                value="${field.value}"
                ${
                  field.name != "company" ? 'required aria-required="true"' : ""
                }
              />
            </div>
          `,
            )
            .join("")}
        </div>
      </form>
    `;

    const quoteItemsSection = `
      <div class="ds-quote-items ds-quote-section">
        <h4 class="ds-quote-section-title">Added products</h4>
        <div class="ds-quote-item-list"></div>
      </div>
    `;

    const noteSection = `
      <div class="ds-quote-note ds-quote-section">
        <label for="ds-quote-note" class="ds-quote-section-title h4">Message</label>
        <textarea id="ds-quote-note" name="ds-quote-note" rows="5" placeholder="Message"></textarea>
      </div>
    `;

    function getFormData() {
      const formData = {};
      const formInputs = document.querySelectorAll(".ds-quote-form input");
      const noteTextarea = document.querySelector("#ds-quote-note");

      formInputs.forEach((input) => {
        formData[input.name] = input.value.trim();
      });

      return {
        firstName: formData.firstName || "",
        lastName: formData.lastName || "",
        title: formData.title || "",
        company: formData.company || "",
        email: formData.email || "",
        phone: formData.phone || "",
        note: noteTextarea?.value?.trim() || "",
      };
    }

    function formatMoney(cents, format) {
      if (typeof cents == "string") {
        cents = cents.replace(".", "");
      }
      var defaultMoneyFormat = "${{amount}}";
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || defaultMoneyFormat;

      function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split(".");
        var dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands,
        );
        var cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function updateQuantity(variantId, newQuantity, type, itemId) {
      const quoteItems = JSON.parse(
        localStorage.getItem("dsQuoteCart") || "[]",
      );
      const updatedItems = quoteItems.map((item) => {
        if (item.id !== Number(itemId)) return item;

        if (type === "main") {
          return {
            ...item,
            variants: item.variants.map((variant) =>
              variant.variantId == variantId
                ? { ...variant, quantity: Math.max(1, parseInt(newQuantity)) }
                : variant,
            ),
          };
        } else {
          return {
            ...item,
            accessories:
              item.accessories?.map((accessory) =>
                accessory.variantId == variantId
                  ? {
                      ...accessory,
                      quantity: Math.max(1, parseInt(newQuantity)),
                    }
                  : accessory,
              ) || [],
          };
        }
      });
      localStorage.setItem("dsQuoteCart", JSON.stringify(updatedItems));
      renderQuoteItems();
    }

    function removeItem(variantId, type, itemId) {
      const quoteItems = JSON.parse(
        localStorage.getItem("dsQuoteCart") || "[]",
      );
      const updatedItems = quoteItems
        .map((item) => {
          if (item.id !== Number(itemId)) return item;

          if (type === "main") {
            return {
              ...item,
              variants: item.variants.filter(
                (variant) => String(variant.variantId) !== String(variantId),
              ),
            };
          } else {
            return {
              ...item,
              accessories:
                item.accessories?.filter(
                  (accessory) => accessory.variantId !== variantId,
                ) || [],
            };
          }
        })
        .filter((item) => item.variants.length > 0);

      localStorage.setItem("dsQuoteCart", JSON.stringify(updatedItems));
      renderQuoteItems();
    }

    function renderVariant(variant, type) {
      return `
        <div class="ds-quote-item__image">
          <img src="${variant.featureImage}" alt="${variant.variantTitle}" />
        </div>
        <div class="ds-quote-item__info">
          <h3>${variant.productTitle}</h3>
          ${
            variant.options_with_values &&
            variant.options_with_values.length > 0
              ? `<div class="product-option">
                  ${variant.options_with_values
                    .map(
                      (option) =>
                        `<span>${option.name}: ${option.value}</span>`,
                    )
                    .join("")}
                </div>`
              : variant.productTitle !== variant.variantTitle
                ? `<div class="product-option">
                  <span>Option: ${variant.variantTitle}</span>
                </div>`
                : ""
          }
          ${
            variant.compareAtPrice
              ? `
            <div class="ds-quote-item__discounted-prices">
              <s class="ds-quote-item__old-price">${formatMoney(
                variant.compareAtPrice,
                window.dsQuoteData.moneyFormat,
              )}</s>
              <strong class="ds-quote-item__final-price">
                ${formatMoney(variant.price, window.dsQuoteData.moneyFormat)}
              </strong>
            </div>
            `
              : `
            <div class="ds-quote-item__final-prices">
              <strong class="ds-quote-item__final-price">
                ${formatMoney(variant.price, window.dsQuoteData.moneyFormat)}
              </strong>
            </div>
            `
          }
        </div>
        <div class="ds-quote-item__quantity">
          <div class="ds-quote-item__quantity-controls">
            <button data-action="decrease" data-variant-id="${
              variant.variantId
            }" data-type="${type}">-</button>
            <input type="number" value="${variant.quantity}" data-variant-id="${
              variant.variantId
            }" data-type="${type}" />
            <button data-action="increase" data-variant-id="${
              variant.variantId
            }" data-type="${type}">+</button>
          </div>
          <button class="ds-quote-item__quantity-remove" data-variant-id="${
            variant.variantId
          }" data-type="${type}">
            <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.994 17.0005H3.5579C3.18682 17.001 2.82971 16.859 2.56032 16.6038C2.29093 16.3485 2.12984 15.9996 2.11031 15.6291L1.45508 3.91113H13.0968L12.4416 15.6291C12.422 15.9996 12.261 16.3485 11.9916 16.6038C11.7222 16.859 11.3651 17.001 10.994 17.0005Z" stroke="black" stroke-miterlimit="10"/>
              <path d="M0 3.91113H14.5522" stroke="black" stroke-miterlimit="10"/>
              <path d="M5.82045 1H8.73088C9.11683 1 9.48697 1.15332 9.75988 1.42622C10.0328 1.69913 10.1861 2.06927 10.1861 2.45522V3.91043H4.36523V2.45522C4.36523 2.06927 4.51855 1.69913 4.79146 1.42622C5.06436 1.15332 5.4345 1 5.82045 1Z" stroke="black" stroke-miterlimit="10"/>
              <path d="M7.27734 6.08887V14.8202" stroke="black" stroke-miterlimit="10"/>
              <path d="M10.1875 6.08887V14.8202" stroke="black" stroke-miterlimit="10"/>
              <path d="M4.36523 6.08887V14.8202" stroke="black" stroke-miterlimit="10"/>
            </svg>
          </button>
        </div>
      `;
    }

    function renderQuoteItems() {
      const quoteItemsContainer = modal.querySelector(".ds-quote-item-list");
      const quoteItems = JSON.parse(
        localStorage.getItem("dsQuoteCart") || "[]",
      );

      quoteItemsContainer.innerHTML = quoteItems
        .map(
          (item) => `
        <div class="ds-quote-item" data-item-id="${item.id}">
          <ul>
            ${item.variants
              .map(
                (variant) => `
              <li>
                ${renderVariant(variant, "main")}
              </li>
            `,
              )
              .join("")}
          </ul>
          ${
            item?.accessories?.length > 0
              ? `
            <div style="height: 1px; display: block; width: 100%; background: rgba(0,0,0,.1)"></div>
            <h6>Accessories</h6>
            <ul>
              ${item.accessories
                .map(
                  (variant) => `
                <li>
                  ${renderVariant(variant, "accessory")}
                </li>
              `,
                )
                .join("")}
            </ul>
          `
              : ``
          }
        </div>
      `,
        )
        .join("");

      quoteItemsContainer
        .querySelectorAll("button[data-action]")
        .forEach((button) => {
          button.addEventListener("click", () => {
            const variantId = button.dataset.variantId;
            const type = button.dataset.type;
            const action = button.dataset.action;
            const itemId = button.closest(".ds-quote-item").dataset.itemId;
            const currentQuantity = parseInt(
              quoteItemsContainer.querySelector(
                `input[data-variant-id="${variantId}"]`,
              ).value,
            );

            updateQuantity(
              variantId,
              action === "increase" ? currentQuantity + 1 : currentQuantity - 1,
              type,
              itemId,
            );
          });
        });

      quoteItemsContainer
        .querySelectorAll(".ds-quote-item__quantity-remove")
        .forEach((button) => {
          button.addEventListener("click", () => {
            const itemId = button.closest(".ds-quote-item").dataset.itemId;
            removeItem(button.dataset.variantId, button.dataset.type, itemId);
          });
        });
    }

    function closeModal() {
      modal.classList.remove("ds-quote-modal--open");
    }

    const modal = document.createElement("div");

    modal.classList.add("ds-quote-modal");

    modal.innerHTML = `
      <div class="ds-quote-modal__content" role="dialog" aria-labelledby="quote-modal-title" aria-modal="true">
        <button class="ds-quote-modal__close" type="button" aria-label="Close quote modal">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17" aria-hidden="true">
            <path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/>
          </svg>
          <span class="visually-hidden">Close</span>
        </button>
        <div class="ds-quote-modal__header">
          <h3 id="quote-modal-title">Create a Quote</h3>
        </div>
        <div class="ds-quote-modal__body">
          ${formSection}
          ${quoteItemsSection}
          ${noteSection}
        </div>
        <div class="ds-quote-modal__footer">
          <button class="ds-quote-modal__submit button button--primary" type="submit" form="ds-quote-form">
            Submit Quote
          </button>
          <div class="ds-quote-modal__response" role="status" aria-live="polite" aria-atomic="true"></div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });

    modal
      .querySelector(".ds-quote-modal__close")
      .addEventListener("click", closeModal);

    modal
      .querySelector(".ds-quote-modal__submit")
      .addEventListener("click", async () => {
        const submitForm = document.querySelector("form.ds-quote-form");
        if (!submitForm) {
          return false;
        }
        if (!submitForm.checkValidity()) {
          submitForm.reportValidity();
          return false;
        }
        const submitButton = modal.querySelector(".ds-quote-modal__submit");
        submitButton.disabled = true;
        submitButton.classList.add("loading");

        try {
          const formData = getFormData();
          const quoteItems = JSON.parse(
            localStorage.getItem("dsQuoteCart") || "[]",
          );

          const response = await apiClient.post("/api/submit_quote", {
            shop: window?.dsQuoteData?.shop,
            data: formData,
            customer: window?.dsQuoteData?.customer,
            items: quoteItems,
          });

          if (response && (response["0"] || response.errors)) {
            let errorMessage = "Please fix the following errors:";

            const errorMessages = [];
            Object.keys(response).forEach((key) => {
              if (!isNaN(key) && response[key] && response[key].message) {
                errorMessages.push(response[key].message);
              }
            });

            if (errorMessages.length > 0) {
              errorMessage = errorMessages.join(", ");
            } else if (response.message) {
              errorMessage = response.message;
            }

            modal.querySelector(".ds-quote-modal__response").innerHTML = `
              <p class="ds-quote-modal__response text-small" style="color: #dc3545; margin-top: 10px;">
                ${errorMessage}
              </p>
            `;
            return;
          }

          localStorage.removeItem("dsQuoteCart");
          modal.querySelector(".ds-quote-modal__content").innerHTML = `
            <button class="ds-quote-modal__close">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>
            </button>
            <div class="ds-quote-confirmation">
              <h3 class="ds-quote-confirmation__heading">Quote Submitted!</h3>
              <p class="ds-quote-confirmation__description">Your quote is now available in your account. Check it out or continue browsing our catalog.</p>
              <div class="ds-quote-confirmation__actions">
                <a class="button button--primary" href="https://shopify.com/${window?.dsQuoteData?.shopId}/account/pages/bb4ab496-ccb3-4524-b5ed-6351b3ee400e">View Quote</a>
                <a class="button button--ghost" href="/">Continue Shopping</a>
              </div>
            </div>
          `;
          modal
            .querySelector(".ds-quote-modal__close")
            .addEventListener("click", closeModal);
        } catch (error) {
          let errorMessage = "An unexpected error occurred. Please try again.";

          if (error.responseData) {
            const responseData = error.responseData;

            if (
              responseData.data &&
              Array.isArray(responseData.data) &&
              responseData.data.length > 0
            ) {
              const errorMessages = responseData.data
                .filter((item) => item.message)
                .map((item) => item.message);

              if (errorMessages.length > 0) {
                errorMessage = errorMessages.join(", ");
              }
            } else if (responseData["0"] && responseData["0"].message) {
              errorMessage = responseData["0"].message;
            } else if (responseData.message) {
              errorMessage = responseData.message;
            } else if (responseData.error) {
              errorMessage = responseData.error;
            }
          }

          modal.querySelector(".ds-quote-modal__response").innerHTML = `
            <p class="ds-quote-modal__response text-small">
              ${errorMessage}
            </p>
          `;
        } finally {
          submitButton.disabled = false;
          submitButton.classList.remove("loading");
        }
      });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          if (modal.classList.contains("ds-quote-modal--open")) {
            renderQuoteItems();
          }
        }
      });
    });

    observer.observe(modal, { attributes: true });

    renderQuoteItems();
  }

  function renderWishlistButton() {
    const product = window?.dsQuoteData?.product;

    const productId = product?.id ?? "";

    async function addToWishList() {
      const item = {
        productId,
        productTitle: product?.title || "",
        productHandle: product?.handle || "",
        featureImage: product?.featured_image || "",
        priceMin: product?.price_min,
        priceMax: product?.price_max,
        compareAtPriceMin: product.compare_at_price_min,
        compareAtPriceMax: product.compare_at_price_max,
      };

      try {
        await apiClient.post("/api/add_wishlist", {
          shop: window?.dsQuoteData?.shop,
          customer: window?.dsQuoteData?.customer,
          item,
        });
        let items = window?.dsQuoteData?.wishlistItems ?? [];
        items.push({
          item,
        });
        window.dsQuoteData.wishlistItems = items;
        updateButtonState();
      } catch (error) {
        console.log("error", error);
      }
    }

    async function removeFromWishlist() {
      try {
        await apiClient.post("/api/delete_wishlist", {
          id: productId,
        });

        let items = window?.dsQuoteData?.wishlistItems;

        const index = items.findIndex(
          (item) => item?.item?.productId === productId,
        );

        if (index > -1) {
          items.splice(index, 1);
        }

        updateButtonState();
      } catch (error) {
        console.log("error", error);
      }
    }

    function isItemInWishlist() {
      const wishlistItems = window?.dsQuoteData?.wishlistItems || [];

      return wishlistItems.some((item) => item.item.productId === productId);
    }

    function updateButtonState() {
      const button = document.querySelector("[data-wishlist-button]");

      if (!button) return;

      if (isItemInWishlist()) {
        button.dataset.saved = "true";
      } else {
        button.dataset.saved = "false";
      }
    }

    let button = document.querySelector("[data-wishlist-button]");

    if (button) {
      updateButtonState();

      button.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const customerId = window?.dsQuoteData?.customer?.id;

        if (!customerId) {
          const returnUrl = encodeURIComponent(window.location.href);
          window.location = window?.dsQuoteData?.loginUrl
            ? window?.dsQuoteData?.loginUrl
            : `/account/login?return_url=${returnUrl}`;
          return;
        }

        if (button.dataset.saved === "true") {
          removeFromWishlist();
        } else {
          addToWishList();
        }
      });
    }
  }

  window.addEventListener("load", function () {
    renderQuoteButton();
    renderQuoteModal();
    renderWishlistButton();
  });
})();
